import { Injectable } from '@angular/core';
import { LoggerService } from '../../app/services/logger.service';  

/*
  Generated class for the MessagesManagerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MessagesManagerProvider {
  public messages: Array<any>;

  constructor(
    public logger: LoggerService
  ) {
    this.logger.debug('Hello MessagesManagerProvider Provider');
    this.messages = [];
  }

}
